import type { FormApi } from 'final-form';
import type { MouseEvent } from 'react';
import React, { useCallback } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { CSSTransition } from 'react-transition-group';

import type { ButtonPropTypes } from '../Button/Button';
import { Button } from '../Button/Button';
import { Loader } from '../Loader';
import styles from './SubmitButton.module.scss';

const transitionClassNames = {
  enter: styles['container-enter'],
  enterActive: styles['container-enterActive'],
  enterDone: styles['container-enterActive'],
  exit: styles['container-exit'],
  exitActive: styles['container-exitActive'],
  exitDone: styles['container-exitActive'],
};

export type SubmitButtonPropTypes = Omit<ButtonPropTypes, 'onClick'> & {
  onClick?: (e: MouseEvent<HTMLButtonElement>, form: FormApi) => void;
};

export const SubmitButton: React.FC<SubmitButtonPropTypes> = ({
  children,
  onClick: propsClick,
  ...props
}) => {
  const form = useForm() as FormApi;
  const { hasValidationErrors, submitting } = useFormState();

  const onClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      if (propsClick) {
        propsClick(event, form);
      }
      form.submit();
    },
    [propsClick, form],
  );

  return (
    <Button {...props} onClick={onClick} type="submit" disabled={hasValidationErrors || submitting}>
      {children}
      <CSSTransition in={submitting} timeout={150} classNames={transitionClassNames}>
        <div className={styles.container}>
          <Loader />
        </div>
      </CSSTransition>
    </Button>
  );
};
